import { useEffect } from "react";
import Footer from "../Footer";
import Header from "../Header";
import BanffNationalPark from "../assets/img/Blogs/NorthAmerica/BanffNationalPark.jpg";
// import Cancún from "../assets/img/Blogs/NorthAmerica/Cancún.jpg";
import NewYorkCity from "../assets/img/Blogs/NorthAmerica/NewYorkCity.jpg";
import Orlando from "../assets/img/Blogs/NorthAmerica/Orlando.jpg";
import SanFrancisco from "../assets/img/Blogs/NorthAmerica/SanFrancisco.jpg";

const NorthAmerica = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header></Header>
      <div className="mainContent blogDtlWrap">
        <div className="blogBannerWrap northAmericaBannerWrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 col-lg-8">
                <div className="bannerDataWrap">
                  <h2>North America</h2>
                  <p>
                    North America is a continent full of contrasts—towering
                    mountains, iconic cities, ancient wonders, and vast natural
                    parks. Whether you're seeking adventure, culture, or
                    relaxation, these top 5 destinations deliver unforgettable
                    experiences.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={NewYorkCity} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>01.</span>
                  <h2> New York City, USA</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      The city that never sleeps, where dreams rise with the
                      skyline.
                    </p>
                  </div>
                  <p>
                    The city that never sleeps is a cultural melting pot, famous
                    for its skyline, art, and diversity. Visit iconic landmarks
                    like Times Square, Central Park, and the Brooklyn Bridge.
                    Catch a Broadway show or explore world-class museums like
                    MoMA and the Met. Don’t forget to try a classic New York
                    slice of pizza!
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        Statue of Liberty – a symbol of freedom and American
                        heritage.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={BanffNationalPark} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>02.</span>
                  <h2> Banff National Park, Canada</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Turquoise lakes, towering peaks, and whispers of wild
                      alpine air.
                    </p>
                  </div>
                  <p>
                    Nestled in the Canadian Rockies, Banff is a paradise for
                    nature lovers and adventure seekers. Hike scenic trails,
                    canoe on turquoise lakes, and spot elk or bears in the wild.
                    The charming town of Banff offers cozy stays and mountain
                    views. Perfect for winter skiing or summer hiking
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        Lake Louise – a stunning glacier-fed lake with emerald
                        waters.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  {/* <img src={Cancún} className="img-fluid" alt="" /> */}
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>03.</span>
                  <h2> Cancún, México</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Turquoise seas, ancient ruins, and sunsets that celebrate
                      life.
                    </p>
                  </div>
                  <p>
                    Known for its white-sand beaches and turquoise Caribbean
                    waters, Cancún is a top beach getaway. Enjoy snorkeling,
                    diving, and vibrant nightlife along the Hotel Zone. Take day
                    trips to cenotes (natural sinkholes) and Mayan ruins. It’s
                    both a relaxing and cultural destination.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        Chichén Itzá – a UNESCO-listed ancient Mayan city
                        nearby.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={Orlando} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>04.</span>
                  <h2> Orlando, USA</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Where imagination comes to life, and every day feels like
                      a dream come true.
                    </p>
                  </div>
                  <p>
                    The theme park capital of the world, Orlando is fun for
                    families and thrill-seekers alike. Explore the magic of Walt
                    Disney World and the wizardry of Universal Studios. Enjoy
                    sunny weather year-round and a wide range of resorts and
                    attractions. Perfect for multi-day vacations.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        Walt Disney World Resort – the most visited vacation
                        resort on the planet.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="blogTopAttraction blogTopAttractionPadBtm">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="imageWrap">
                  <img src={SanFrancisco} className="img-fluid" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="dataWrap">
                  <span>05.</span>
                  <h2> San Francisco, USA</h2>
                  <div className="location">
                    <svg
                      viewBox="0 0 24 24"
                      width="20px"
                      height="20px"
                      class="d Vb hzzSG UmNoP"
                      ariaHidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4.25 9.799c0-4.247 3.488-7.707 7.75-7.707s7.75 3.46 7.75 7.707c0 2.28-1.138 4.477-2.471 6.323-1.31 1.813-2.883 3.388-3.977 4.483l-.083.083-.002.002-1.225 1.218-1.213-1.243-.03-.03-.012-.013c-1.1-1.092-2.705-2.687-4.035-4.53-1.324-1.838-2.452-4.024-2.452-6.293M12 3.592c-3.442 0-6.25 2.797-6.25 6.207 0 1.796.907 3.665 2.17 5.415 1.252 1.736 2.778 3.256 3.886 4.357l.043.042.16.164.148-.149.002-.002.061-.06c1.103-1.105 2.605-2.608 3.843-4.322 1.271-1.76 2.187-3.64 2.187-5.445 0-3.41-2.808-6.207-6.25-6.207m1.699 5.013a1.838 1.838 0 1 0-3.397 1.407A1.838 1.838 0 0 0 13.7 8.605m-2.976-2.38a3.338 3.338 0 1 1 2.555 6.168 3.338 3.338 0 0 1-2.555-6.169"
                      ></path>
                    </svg>
                    <p>
                      Where fog hugs the hills and a golden bridge leads to
                      endless possibilities.
                    </p>
                  </div>
                  <p>
                    A hilly city with charm, tech innovation, and a bohemian
                    past. Explore colorful Victorian houses, bustling piers, and
                    panoramic coastal views. Ride a cable car, tour Alcatraz
                    Island, and stroll through Chinatown. The city is a great
                    mix of nature and culture.
                  </p>
                  <h4>Top Attractions</h4>
                  <ul>
                    <li>
                      <p>
                        Golden Gate Bridge – the city’s most iconic and
                        photogenic landmark.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="styConnectedWrap">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="styConnectedBox">
                  <div className="imgWrap">
                    <img src={NewYorkCity} className="img-fluid" alt="" />
                  </div>
                  <div className="dataWrap">
                    <h2> Start planning your Russia adventure today!</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </>
  );
};
export default NorthAmerica;
